export const getCurrentLanguage = (language) => {
  return language.isNepali ? "np" : "en";
};
